import shopifyGenericDefaults from '../shopify-dawn-generic/config.js';

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-dawn-generic'],
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['SearchBox', 'SearchBoxDialogButton'].includes(w.name)),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      location: {
        replace: '.custom_search_wrapper .search-modal__content .search-modal__form',
        class: 'search-modal__form',
      },
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBoxDialogButton'),
      location: {
        replace: '.mobile_only .header__search',
        class: 'header__search cm_desktop-hide cm_search-box-root__dialog_open-button-container',
      },
    },
  ],
};
